import { apiHelper } from '../api_helper';

export const SMS_NEW_ENDPOINT = 'sms_new';
export const smsNewApi = {
    SelectByCoSo: (dm_coso_id) => apiHelper.get(`${SMS_NEW_ENDPOINT}/coso/${dm_coso_id}`),
    SelectUsers: (smsId) => apiHelper.get(`${SMS_NEW_ENDPOINT}/${smsId}/users`),
    SelectById: (smsId) => apiHelper.get(`${SMS_NEW_ENDPOINT}/${smsId}`),
    SavePheDuyet: (smsId) => apiHelper.post(`${SMS_NEW_ENDPOINT}/send-sms/${smsId}`),
    RejectSms: (smId) => apiHelper.post(`${SMS_NEW_ENDPOINT}/tuchoi-pheduyet`, smId),
    ApproveSms: (smId) => apiHelper.post(`${SMS_NEW_ENDPOINT}/pheduyet`, smId),
    SaveAsync: (datasend) => apiHelper.post(`${SMS_NEW_ENDPOINT}/save-async`, datasend),
    Detail: (id) => apiHelper.get(`${SMS_NEW_ENDPOINT}/${id}`),
    Insert: (datasend) => apiHelper.post(SMS_NEW_ENDPOINT, datasend),
    Update: (data) => apiHelper.put(SMS_NEW_ENDPOINT, data),
    Delete: (id) => apiHelper.delete(`${SMS_NEW_ENDPOINT}/${id}`),
    
}